import Iconify from '@/components/iconify/index.tsx';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { usePickemStore } from '@/store/usePickem.store.ts';
import { useState } from 'react';
import { useSendPrizeNotificationsMutation } from '@/api/send-prize-notifications.ts';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';

export const SendPrizeEmailButton = () => {
  const { pickemId, leagueId, tournamentId } = useAppSearchParams();
  const { checkedUsers } = usePickemStore();

  const [openSendEmail, setOpenSendEmail] = useState(false);
  const [sendEmailText, setSendEmailText] = useState({
    prize_text_en: '',
    prize_text_lv: '',
    prize_text_et: '',
    prize_text_ru: '',
    prize_text_sk: '',

    contestname_en: '',
    contestname_ru: '',
    contestname_lv: '',
    contestname_et: '',
    contestname_sk: '',
  });

  const { mutateAsync: sendPrizeNotification, isPending } =
    useSendPrizeNotificationsMutation();

  const handleOpenSendEmailDialog = () => {
    setSendEmailText({
      prize_text_en: '',
      prize_text_lv: '',
      prize_text_et: '',
      prize_text_ru: '',
      prize_text_sk: '',

      contestname_en: '',
      contestname_ru: '',
      contestname_lv: '',
      contestname_et: '',
      contestname_sk: '',
    });
    setOpenSendEmail(true);
  };

  const handleChangeEmailFields = (e: any) => {
    const { id, value } = e.target;

    setSendEmailText((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSendEmail = () => {
    sendPrizeNotification({
      ...sendEmailText,
      user_ids: checkedUsers,
      pickem_id: pickemId,
      league_id: leagueId,
      tournament_id: tournamentId,
    }).then(() => {
      setOpenSendEmail(false);
    });
  };

  if (!checkedUsers.length) return null;

  return (
    <>
      <Button
        variant='outlined'
        startIcon={<Iconify icon='eva:paper-plane-outline' />}
        onClick={() => handleOpenSendEmailDialog()}
        sx={{ mr: 2 }}
        disabled={isPending}
      >
        Send Prize Email
      </Button>

      <Dialog
        open={openSendEmail}
        onClose={() => {}}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth
        maxWidth='md'
      >
        <DialogTitle id='alert-dialog-title'>Send Email</DialogTitle>
        <DialogContent>
          <TextField
            id='prize_text_en'
            label='Prize Text EN'
            fullWidth
            value={sendEmailText.prize_text_en}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='prize_text_lv'
            label='Prize Text LV'
            fullWidth
            value={sendEmailText.prize_text_lv}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='prize_text_ru'
            label='Prize Text RU'
            fullWidth
            value={sendEmailText.prize_text_ru}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='prize_text_et'
            label='Prize Text ET'
            fullWidth
            value={sendEmailText.prize_text_et}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='prize_text_sk'
            label='Prize Text SK'
            fullWidth
            value={sendEmailText.prize_text_sk}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='contestname_en'
            label='Contest Name EN'
            fullWidth
            value={sendEmailText.contestname_en}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='contestname_lv'
            label='Contest Name LV'
            fullWidth
            value={sendEmailText.contestname_lv}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='contestname_ru'
            label='Contest Name RU'
            fullWidth
            value={sendEmailText.contestname_ru}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='contestname_et'
            label='Contest Name ET'
            fullWidth
            value={sendEmailText.contestname_et}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
          <TextField
            id='contestname_sk'
            label='Contest Name SK'
            fullWidth
            value={sendEmailText.contestname_sk}
            variant='standard'
            onChange={handleChangeEmailFields}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSendEmail(false)}>Cancel</Button>
          <Button onClick={() => handleSendEmail()} autoFocus>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
